function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.2635 1.14214C5.48815 1.01566 5.7416 0.949219 5.9994 0.949219C6.2572 0.949219 6.51065 1.01566 6.7353 1.14214C6.95994 1.26862 7.1482 1.45086 7.2819 1.67128L7.28334 1.67365L11.5183 8.74366L11.5224 8.75056C11.6534 8.97738 11.7227 9.23454 11.7234 9.49645C11.7241 9.75837 11.6563 10.0159 11.5266 10.2435C11.3969 10.471 11.2099 10.6606 10.9841 10.7934C10.7584 10.9263 10.5018 10.9977 10.2399 11.0006L10.2344 11.0006L1.7589 11.0006C1.497 10.9977 1.24042 10.9263 1.01469 10.7934C0.788949 10.6606 0.601926 10.471 0.472225 10.2435C0.342523 10.0159 0.274663 9.75837 0.275397 9.49645C0.27613 9.23454 0.345431 8.97738 0.476405 8.75056L0.480466 8.74366L4.71547 1.67366L5.14439 1.93059L4.7169 1.67128C4.8506 1.45086 5.03886 1.26862 5.2635 1.14214ZM5.57251 2.18891L1.34074 9.2535C1.29815 9.3284 1.27563 9.41305 1.27539 9.49925C1.27515 9.58656 1.29777 9.6724 1.341 9.74825C1.38424 9.8241 1.44658 9.88731 1.52182 9.93158C1.59641 9.97547 1.6811 9.99924 1.7676 10.0006H10.2312C10.3177 9.99924 10.4024 9.97547 10.477 9.93158C10.5522 9.88731 10.6146 9.8241 10.6578 9.74825C10.701 9.6724 10.7237 9.58656 10.7234 9.49925C10.7232 9.41306 10.7007 9.32842 10.6581 9.25353L6.4269 2.1899C6.4267 2.18957 6.4265 2.18924 6.4263 2.18891C6.38177 2.11588 6.31924 2.05549 6.2447 2.01353C6.16982 1.97137 6.08533 1.94922 5.9994 1.94922C5.91347 1.94922 5.82898 1.97137 5.7541 2.01353C5.67956 2.05549 5.61704 2.11588 5.57251 2.18891Z",
  fill: "#FE3745"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6 4C6.27614 4 6.5 4.22386 6.5 4.5V6.5C6.5 6.77614 6.27614 7 6 7C5.72386 7 5.5 6.77614 5.5 6.5V4.5C5.5 4.22386 5.72386 4 6 4Z",
  fill: "#FE3745"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.5 8.5C5.5 8.22386 5.72386 8 6 8H6.005C6.28114 8 6.505 8.22386 6.505 8.5C6.505 8.77614 6.28114 9 6.005 9H6C5.72386 9 5.5 8.77614 5.5 8.5Z",
  fill: "#FE3745"
});

var SvgAlertTriangle = function SvgAlertTriangle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlertTriangle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/alert-triangle.02d691f0.svg";
export { ForwardRef as ReactComponent };